/**
 * 商城 - 商品列表
 * 1 排 2 个卡片：悟空听说7年成长通关计划 + 占位（待后续填充）
 * 无需登录即可访问
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import mallCover from 'asset/img/mall.png';
import './index.scss';

// 商品列表（静态，后续可接接口）
const MALL_PRODUCTS = [
  {
    id: 'vip',
    name: '3-12岁英语听说黄金期成长计划',
    subtitle: '畅听畅学，解锁全部内容',
    cover: mallCover,
    price: 6980,
    priceLabel: '¥6980',
    sales: '5100+',
    promotion: '拍5送2',
  },
  {
    id: 'placeholder',
    name: '更多好物',
    subtitle: '即将上线',
    cover: '',
    price: 0,
    priceLabel: '敬请期待',
    disabled: true,
  },
];

const Mall = () => {
  const navigate = useNavigate();

  const handleCardClick = (item) => {
    if (item.disabled) return;
    navigate(`/mall/product/${item.id}`);
  };

  return (
    <div className="mall-page">
      <header className="mall-header">
        <h1 className="mall-title">商城</h1>
      </header>
      <section className="mall-list">
        {MALL_PRODUCTS.map((item) => (
          <div
            key={item.id}
            className={`mall-card ${item.disabled ? 'mall-card--disabled' : ''}`}
            onClick={() => handleCardClick(item)}
          >
            <div className="mall-card__cover">
              {item.cover ? (
                <img src={item.cover} alt={item.name} />
              ) : (
                <div className="mall-card__placeholder">敬请期待</div>
              )}
            </div>
            <div className="mall-card__info">
              <div className="mall-card__name">{item.name}</div>
              {item.promotion && <div className="mall-card__promotion">{item.promotion}</div>}
              <div className="mall-card__subtitle">{item.subtitle}</div>
              {item.sales && <div className="mall-card__sales">已售 {item.sales}</div>}
              <div className="mall-card__price">
                {item.id === 'vip' ? <>券后 {item.priceLabel}</> : item.priceLabel}
              </div>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Mall;
